import React from 'react';
import Img from 'gatsby-image';

import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    copyText: {
      position: 'absolute',
      bottom: '0px',
      left: '10px',
      color: 'white',
      fontStyle: 'italic',
    },
    image: {
      width: '100%',
      maxWidth: '100%',
      height: 'auto',
      objectFit: 'contain',
    },
    container: {
      width: '100%',
      display: 'flex',
      height: 'auto',
      position: 'relative',
    },
  }),
);

const WrappedImg = (props) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <Img {...props} className={classes.image} />
      <p className={classes.copyText}> &copy; {props.copyText}</p>
    </div>
  );
};

export default WrappedImg;
